module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h2', [_vm._v("Account")]), _vm._v(" "), _c('h4', [_vm._v("Most Used Ingredients")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.ingredientsUsed), function(item, index) {
    return _c('li', {
      staticClass: "list-item"
    }, [_vm._v("\t\t\t\n\t\t\t\t" + _vm._s(item.total) + " " + _vm._s(item.name) + "\n\t\t\t")])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34a716d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account.vue
// module id = 133
// module chunks = 0